import { Component, ChangeDetectionStrategy } from '@angular/core';
import {MetaTitle} from '../../../../decorator/meta-title';

@Component({
  selector: 'app-api',
  imports: [],
  templateUrl: './api.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './api.component.scss'
})
@MetaTitle('Reporting API')
export class ApiComponent {

}
